// Variables
const body = document.querySelector("body");
const importedVideo = document.querySelector(`.video-player`);
const player = new window.Vimeo.Player(importedVideo);
const modal = document.querySelector(`.modal`);
const modals = document.querySelectorAll(`.modal`);
const closeButtons = document.querySelectorAll(".modal__close");
const modalOverlay = document.querySelector(`.modal__overlay`);
const rules = document.querySelector(`.hero__link`);
const rulesModal = document.querySelector(`#rules`);
const video = document.querySelector(`.video__controls`);
const videoModal = document.querySelector(`#video`);
const submitModal = document.querySelector(`#submit`);
const rulesFoot = document.querySelector(".footer__rules");

//Click events for modal spawning elements
// rules.addEventListener("click", function(e) {
//     e.preventDefault();
//     openModal(rulesModal);
// });

// rulesFoot.addEventListener("click", function(e) {
//     e.preventDefault();
//     openModal(rulesModal);
// });

video.addEventListener("click", function(e) {
    e.preventDefault();
    openModal(videoModal);
});

// Helper function to stop video playing once the video modal is closed
var stopVideo = function() {
    player.pause();
    player.setCurrentTime(0);
};

/**
 * openModal handles the opening of a modal. The modal must be passed via eventlisteners
 * from the proper access point. This function can handle additional modals via new cases
 * and create specific functionality for them.
 *
 * @param {*} modal
 */
export var openModal = function(modal) {
    //body.style.overflow = "hidden";
    document.body.dataset.modalOpen = true;
    document.body.setAttribute("data-modal-open", "true");
    switch (modal.id) {
        case "rules":
            //rulesModal.dataset.modalOpen = true;
            rulesModal.setAttribute("data-modal-open", "true");
            trapFocus(rulesModal);
            break;
        case "video":
            videoModal.dataset.modalOpen = true;
            videoModal.setAttribute("data-modal-open", "true");
            player.play();
            trapFocus(videoModal);
            break;
        case "submit":
            submitModal.setAttribute("data-modal-open", "true");
            trapFocus(submitModal);
            break;
    }
};

var trapFocus = function(modal) {
    const bgElements = document.querySelectorAll('.tabbable, [tabindex="0"]');

    for (let i = 0; i < bgElements.length; i++) {
        bgElements[i].setAttribute("tabindex", "-1");
    }
    const focusable = modal.querySelectorAll("a, iframe");
    document.querySelector(".modal__list-wrapper").setAttribute("tabindex", "0");

    setTimeout(function() {
        const lastIndex = focusable[focusable.length - 1];
        focusable[0].focus();
        lastIndex.addEventListener("keydown", function(e) {
            if (e.which === 9 && !e.shiftKey) {
                console.log("running");
                e.preventDefault();
                focusable[0].focus();
                lastIndex.blur();
            }
        });

        focusable[0].addEventListener("keydown", function(e) {
            if (e.which === 9 && e.shiftKey) {
                e.preventDefault();
                lastIndex.focus();
                focusable[0].blur();
            }
        });

        document.body.addEventListener("keyup", function(e) {
            let inModal = true;

            // Regular tabbing
            if (e.which === 9 && !e.shiftKey) {
                lockFocus(e, index[0]);
            }

            // Shift tabbing
            if (e.which === 9 && e.shiftKey) {
                lockFocus(e, index[index.length - 1]);
            }
        });

        //const focusable = modal.querySelectorAll("a, iframe");
        //const lastIndex = focusable[focusable.length - 1];
        focusable[0].focus();

        lastIndex.addEventListener("keydown", function(e) {
            if (e.which === 9) {
                focusable[0].focus();
                e.preventDefault();
            }
        });

        focusable[0].addEventListener("keydown", function(e) {
            if (e.which === 9 && e.shiftKey) {
                lastIndex.focus();
                focusable[0].blur();
                e.preventDefault();
            }
        });
    }, 31);
};

var lockFocus = function(e, index) {
    let parent = document.activeElement.parentNode;
    while (!parent.classList.contains("modal") && parent.tagName !== "HTML") {
        parent = parent.parentNode;
    }
    if (!parent.classList.contains("modal")) {
        let openModal = document.querySelector('.modal[data-modal-open="true"]');
        if (openModal !== null) {
            e.preventDefault();
            index.focus();
        }
    }
};

// For loop for closing Modals using the "Close" link
for (const closeButton of closeButtons) {
    closeButton.addEventListener("click", function(e) {
        e.preventDefault();
        let parent = this.parentNode;
        while (!parent.classList.contains("modal") && parent.tagName !== "HTML") {
            parent = parent.parentNode;
        }

        parent.setAttribute("data-modal-open", "false");
        // console.log(this.parentNode.getElementByID);
        // this.parentNode.setAttribute("data-modal-open", "false");
        document.body.setAttribute("data-modal-open", "false");
        if (parent.id == "video") {
            stopVideo();
        }
        const bgElements = document.querySelectorAll('.tabbable, [tabindex="0"]');
        for (let i = 0; i < bgElements.length; i++) {
            bgElements[i].setAttribute("tabindex", "0");
        }
    });
}

// Event that closes the modal if the user clicks anywhere on the modal
for (const mod of modals) {
    mod.addEventListener("click", function(e) {
        if (e.target == mod) {
            mod.dataset.modalOpen = false;
            document.body.dataset.modalOpen = false;
            if (mod.id == "video") {
                stopVideo();
            }
        }
        const bgElements = document.querySelectorAll('.tabbable, [tabindex="0"]');
        for (let i = 0; i < bgElements.length; i++) {
            bgElements[i].setAttribute("tabindex", "0");
        }
    });
}

// If user escapes, close the modal
document.addEventListener(`keydown`, e => {
    if (e.code === `Escape` || e.which === 27) {
        for (const mod of modals) {
            //mod.dataset.modalOpen = false;
            mod.setAttribute("data-modal-open", "false");
            //document.body.dataset.modalOpen = false;
            document.body.setAttribute("data-modal-open", "false");
            if (mod.id == "video") {
                stopVideo();
            }
        }
        const bgElements = document.querySelectorAll('.tabbable, [tabindex="0"]');
        for (let i = 0; i < bgElements.length; i++) {
            bgElements[i].setAttribute("tabindex", "0");
        }
    }
});
